// src/utils/dateHelper.js

// dateHelper.js

/**
 * Calculate the difference between two dates.
 * 
 * @param {Date} date1 - The first date.
 * @param {Date} date2 - The second date.
 * @returns {Object} An object containing the difference in days, hours, minutes, and seconds.
 */
 function getDateDifference(fromDate, toDate) {
  // Parse the date strings to Date objects
  const date1 = new Date(fromDate);
  const date2 = new Date(toDate);

  // Ensure both inputs are valid Date objects
  if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
    throw new Error('Invalid date format. Dates must be in ISO 8601 format.');
  }

  // Calculate the difference in milliseconds
  const diffInMs = Math.abs(date2 - date1);

  // Convert milliseconds to time components
  const diffInSeconds = Math.floor(diffInMs / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  return {
    days: diffInDays,
    hours: diffInHours % 24,
    minutes: diffInMinutes % 60,
    seconds: diffInSeconds % 60,
  };
}

function formatDate(isoString) {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;

};

function calculateAge(dob) {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();
  const dayDifference = today.getDate() - birthDate.getDate();

  // Adjust age if the current date is before the birthday
  if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
    age--;
  }
  return age;
}

module.exports = {
  getDateDifference,
  formatDate,
  calculateAge
};



  
